import Vue from 'vue';
import Vuex from 'vuex';

const state = {
  params: {
    page: 1,
    per_page: 30,
    q: {
      name: '',
      store_name: ''
    }
  }
};

const mutations = {
  changeCompartmentPage(state, val) {
    state.params = val;
  }
};

export default {
  state,
  mutations
};
